/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ProcedureItemList } from '../../models/procedure-item-list';

export interface ProcedureControllerGetAll$Params {
  field?: 'id' | 'companyName' | 'createdOn' | 'fiscalCode' | 'status.id' | 'requestedByUser.lastName';
  direction?: 'asc' | 'desc';
  id?: number;
  companyName?: string;
  query?: string;
  fiscalCode?: string;
  from?: string;
  to?: string;
  limit?: number;
  skip?: number;
  procedureStateId?: number;
  requestedByCompanyId?: number;
  procedureTypeIds?: Array<number>;
}

export function procedureControllerGetAll(http: HttpClient, rootUrl: string, params?: ProcedureControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProcedureItemList;
}>> {
  const rb = new RequestBuilder(rootUrl, procedureControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('field', params.field, {});
    rb.query('direction', params.direction, {});
    rb.query('id', params.id, {});
    rb.query('companyName', params.companyName, {});
    rb.query('query', params.query, {});
    rb.query('fiscalCode', params.fiscalCode, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('procedureStateId', params.procedureStateId, {});
    rb.query('requestedByCompanyId', params.requestedByCompanyId, {});
    rb.query('procedureTypeIds', params.procedureTypeIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ProcedureItemList;
      }>;
    })
  );
}

procedureControllerGetAll.PATH = '/procedure';
